// store/trendelantero/index.js

//inicio storage
const STORAGE_SEARCH = 'leon_trendelantero_search';
const STORAGE_DETALLE_AGENDAMIENTO = 'leon_trendelantero_detalle_agendamiento';
const STORAGE_PERSONAL_INFORMATION = 'leon_trendelantero_personal_information'; // NUEVO

const getSearchStorage = () => {
  try {
    if (import.meta.client) {
      const search = localStorage.getItem(STORAGE_SEARCH);
      return search ? JSON.parse(search) : null;
    }
  } catch (error) {
    console.warn('Error leyendo search:', error);
  }
  return null;
};

const getDetalleAgendamientoStorage = () => {
  try {
    if (import.meta.client) {
      const productos = localStorage.getItem(STORAGE_DETALLE_AGENDAMIENTO);
      return productos ? JSON.parse(productos) : null;
    }
  } catch (error) {
    console.warn('Error leyendo detalle agendamiento:', error);
  }
  return null;
};

// NUEVO
const getPersonalInformationStorage = () => {
  try {
    if (import.meta.client) {
      const personal = localStorage.getItem(STORAGE_PERSONAL_INFORMATION);
      return personal ? JSON.parse(personal) : null;
    }
  } catch (error) {
    console.warn('Error leyendo personal information:', error);
  }
  return null;
};

const setToStorage = (storage, data) => {
  try {
    if (import.meta.client) {
      localStorage.setItem(storage, JSON.stringify(data));
    }
  } catch (error) {
    console.warn('Error guardando en localStorage:', error);
  }
};
//termino storage

//inicio state
const state = function() {
  return {
    searchData: {
      local: '',
      local_id: null,
      modo_busqueda: 'por_auto',
      patente: '',
      marca: '',
      ano: '',
      modelo: '',
    },
    detalle_agendamiento: {
      local_direccion: '',
      modalidad: 1,
      fecha: null,
      hora: null,
      tempario: '',
      direccion_retiro: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      },
      direccion_entrega: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      }
    },
    //como meto esto en usecartbridge sin romper nada?
    personalInformation: {
      rut: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      email: "",
      telefono: "",
      patente: "",
      patente_pais: "",
    },
  };
};
//termino state

const mutations = {
  // Cargar desde localStorage
  LOAD_FROM_STORAGE: function(state) {
    const storedData = getSearchStorage();
    if (storedData) {
      if (!storedData.modo_busqueda) storedData.modo_busqueda = 'por_auto';

      if (storedData.local_id === undefined) storedData.local_id = null;

      state.searchData = { ...state.searchData, ...storedData };
      setToStorage(STORAGE_SEARCH, state.searchData);
    }

    const DetalleAgendamiento = getDetalleAgendamientoStorage();
    if (DetalleAgendamiento) {
      if (typeof DetalleAgendamiento.modalidad === 'string') {
        const mapeoModalidad = { 'ESPERA': 1, 'DEJA': 2, 'RETIRA': 3 };
        DetalleAgendamiento.modalidad = mapeoModalidad[DetalleAgendamiento.modalidad] || 1;
      }
      if (!DetalleAgendamiento.modalidad) {
        DetalleAgendamiento.modalidad = 1;
      }

      if (DetalleAgendamiento.direccion_retiro) {
        delete DetalleAgendamiento.direccion_retiro.misma_direccion;
        delete DetalleAgendamiento.direccion_retiro.dejar_auto;
      }
      if (DetalleAgendamiento.direccion_entrega) {
        delete DetalleAgendamiento.direccion_entrega.misma_direccion;
        delete DetalleAgendamiento.direccion_entrega.dejar_auto;
      }

      state.detalle_agendamiento = {
        ...state.detalle_agendamiento,
        ...DetalleAgendamiento
      };
      console.log('[STORE] Datos cargados desde localStorage para detalle_agendamiento:', state.detalle_agendamiento);
    }

    const PersonalInfo = getPersonalInformationStorage();
    if (PersonalInfo) {
      state.personalInformation = PersonalInfo;
      console.log('[STORE] Datos cargados desde localStorage para personalInformation:', state.personalInformation);
    }
  },
  
  // Resets
  RESET_SEARCH_DATA: function(state) {
    state.searchData = {
      local: '',
      local_id: null,
      modo_busqueda: 'por_auto',
      patente: '',
      marca: '',
      ano: '',
      modelo: '',
    };
    if (import.meta.client) {
      localStorage.removeItem(STORAGE_SEARCH);
    }
  },
  
  RESET_DETALLE_AGENDAMIENTO: function(state) {
    state.detalle_agendamiento = {
      local_direccion: '',
      modalidad: 1,
      fecha: null,
      hora: null,
      direccion_retiro: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      },
      direccion_entrega: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      }
    };
    if (import.meta.client) {
      localStorage.removeItem(STORAGE_DETALLE_AGENDAMIENTO);
    }
  },

  // NUEVO
  RESET_PERSONAL_INFORMATION: function(state) {
    state.personalInformation = {
      rut: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      email: "",
      telefono: "",
      patente: "",
      patente_pais: "",
    };
    if (import.meta.client) {
      localStorage.removeItem(STORAGE_PERSONAL_INFORMATION);
    }
  },


  // Sets - Search Data
  SET_SEARCH_DATA: function(state, data) {
    state.searchData = { ...state.searchData, ...data };
    setToStorage(STORAGE_SEARCH, state.searchData);
  },

  SET_PATENTE_SEARCH: function(state, { patente, local, local_id }) {
    // ✅ si no viene local_id, conserva el actual
    const id_final = (local_id === undefined) ? state.searchData.local_id : local_id

    state.searchData = {
      ...state.searchData,
      patente,
      local,
      local_id: id_final ?? null,
      modo_busqueda: 'por_patente',
      marca: '',
      ano: '',
      modelo: '',
    }

    setToStorage(STORAGE_SEARCH, state.searchData)
  },

  SET_AUTO_SEARCH: function(state, { marca, ano, modelo, local, local_id }) {
    // ✅ si no viene local_id, conserva el actual
    const id_final = (local_id === undefined) ? state.searchData.local_id : local_id

    state.searchData = {
      ...state.searchData,
      marca,
      ano,
      modelo,
      local,
      local_id: id_final ?? null,
      modo_busqueda: 'por_auto',
      patente: '',
    }

    setToStorage(STORAGE_SEARCH, state.searchData)
  },
  
  // Sets - Detalle Agendamiento
  SET_DETALLE_AGENDAMIENTO: function(state, data) {
    state.detalle_agendamiento = { 
      ...state.detalle_agendamiento, 
      ...data 
    };
    setToStorage(STORAGE_DETALLE_AGENDAMIENTO, state.detalle_agendamiento);
  },

  // NUEVO - Sets - Personal Information
  SET_PERSONAL_INFORMATION: function(state, personalInfo) {
    state.personalInformation = {
      ...state.personalInformation,
      ...personalInfo
    };
    setToStorage(STORAGE_PERSONAL_INFORMATION, state.personalInformation);
  },
};

const getters = {
  getFullData: function(state) {
    return {
      searchData: state.searchData,
      detalle_agendamiento: state.detalle_agendamiento,
      personalInformation: state.personalInformation, // NUEVO
    }
  },

  getSearchData: function(state) {
    return state.searchData;
  },
  
  getDetalleAgendamiento: function(state) {
    return state.detalle_agendamiento;
  },

  // NUEVO
  getPersonalInformation: function(state) {
    return state.personalInformation;
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {}
};